import { useState, useRef, useEffect } from "react";
import autoAnimate from "@formkit/auto-animate";
import "./about.css"

 const Levelskill= () => {
  const [open, setOpen] = useState(false);
  const parentRef = useRef();

  useEffect(() => {
    if (parentRef.current) {
      autoAnimate(parentRef.current);
    }
  }, [parentRef]);

  const showMore = () => setOpen(!open);

  return (
    <section className="education flex justify-center items-center flex-col space-y-3 p-3 ">
      <div
        className="px-2 cursor-pointer py-1 border-2 border-gray-150 w-[150px] rounded-md"
        ref={parentRef}
      >
        <div
          onClick={showMore}
          class="tab-links"
        >
          <span>Education</span>
        </div>

        {open && (
              <div class="tab-contents">
              <ul>
                <li>
                  <span>2017</span> complete SSC from Bakai Niranjan High School.
                </li>
                <li>
                  <span>2019</span> complete HSC from Shahid Smriti College.
                </li>
                <li>
                  <span>2024</span> Graduation from BCSE of IUBAT University.
                </li>
              </ul>
            </div>
        )}
      </div>
    </section>
  );
}


export default Levelskill;
